type Listener = (payload: unknown) => void;

type Subscription = {
  event: string;
  callback: Listener;
};

class EventBus {
  private listeners: Subscription[] = [];

  emit(event: string, payload: unknown) {
    this.listeners
      .filter((entry) => entry.event === event)
      .forEach((entry) => entry.callback(payload));
  }

  subscribe(event: string, callback: Listener) {
    const entry = { event, callback };
    this.listeners.push(entry);
    return () => {
      this.listeners = this.listeners.filter((item) => item !== entry);
    };
  }
}

export const EVENTS = {
  GRAPH_UPDATE: 'graph.update',
  NODE_SELECTED: 'graph.node.selected',
  ENTITIES_DETECTED: 'editor.entities.detected',
};

export const globalEventBus = new EventBus();
